/**
 * Shared - Icon Component
 * 
 * Componente wrapper para iconos que funciona en todas las plataformas.
 * En nativo usa react-native-vector-icons, en web usa emojis o CSS.
 */

import React from 'react';
import {Platform, Text, StyleSheet} from 'react-native';

// Solo importar en plataformas nativas
let MaterialIcons: any = null;
if (Platform.OS !== 'web') {
  MaterialIcons = require('react-native-vector-icons/MaterialIcons').default;
}

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: any;
}

// Mapeo de iconos Material a emojis para web
const iconEmojiMap: {[key: string]: string} = {
  'camera-alt': '📷',
  'qr-code-2': '📱',
  'qr-code': '📱',
  'apps': '📊',
  'dashboard': '📊',
  'logout': '🚪',
  'arrow-back': '←',
  'close': '✕',
  'check': '✓',
  'error': '⚠️',
  'warning': '⚠️',
  'info': 'ℹ️',
  'menu': '☰',
  'person': '👤',
  'settings': '⚙️',
  'search': '🔍',
  'home': '🏠',
  'refresh': '🔄',
};

export const Icon: React.FC<IconProps> = ({name, size = 24, color = '#000', style}) => {
  if (Platform.OS === 'web') {
    // En web, usar emoji o texto
    const emoji = iconEmojiMap[name] || '•';
    return (
      <Text
        style={[
          styles.webIcon,
          {
            fontSize: size,
            color,
          },
          style,
        ]}>
        {emoji}
      </Text>
    );
  }

  // En nativo, usar react-native-vector-icons
  if (MaterialIcons) {
    return <MaterialIcons name={name} size={size} color={color} style={style} />;
  }

  // Fallback si no está disponible
  return <Text style={[{fontSize: size, color}, style]}>•</Text>;
};

const styles = StyleSheet.create({
  webIcon: {
    textAlign: 'center',
    lineHeight: undefined, // Dejar que el navegador maneje
  },
});
